function initBroadcastReplyEvent(channel){

    socket.on(channel + ':App\\Events\\Broadcasts\\BroadcastReplyEvent', function (data) {
        $('.timeline-replies', '.timeline-item[data-post="' + data.post.id + '"]').append(
            data.reply
        );

        $('.reply-count', '.timeline-item[data-post="' + data.post.id + '"]').text(parseInt($('.reply-count', '.timeline-item[data-post="' + data.post.id + '"]').text()) + 1);

        $('.boost-reply-ajax').on('click', boost_reply);
    });

}